import { getFormattedDate, getPersonName, getTargetBCPText, getNotAvailableText } from '../../web/section_sf/Utils.js'
import { EnvironmentMap, getCurrentVendorSite } from '../utils/CommonUtil.js'
import { getLogger } from '@olympeio/core';
import { Config } from "olympe";
import BCP from '../section_bcp/DM_BCP.js';
import { uniqueListByProperty, callProxyFunction } from "../utils/CommonUtil.js"



export const generateAGQAEmailContents = async (name, bcpRequestArray, partner, statement, $) => {
  const logger = getLogger('BCPQAEmailTemplate')
  const docLink = Config.getParameter('qrcAcceptRejectExplanationLink');
  let emailContent = `
  <p>Dear ${name},</p>
  <p>You have received BCP request(s) that are pending your evaluation.</p>
  <p><b><u>Expected action as a ${partner}:</u></b> ${statement} </p>
  <p>To accept/reject a BCP request, please click on this <a href="${getFullURL()}">link</a> to go to the Ensuring Supply WebApp and go to the “Manage BCP Request” tab. To understand how to accept/reject a BCP requests, please click on this <a href="${docLink}">link.</a></p>
  <b>Following BCP request(s) are waiting for your input as a ${partner}:</b><br/>
  <table border="1" cellpadding="5" cellspacing="0" style="border-collapse: collapse;">
    <thead>
      <tr>
        <th style="text-align: left; vertical-align: top; width:90px">Plant</th>
        <th style="text-align: left; vertical-align: top; width:200px">Material</th>
        <th style="text-align: left; vertical-align: top; width:120px">Specification</th>
        <th style="text-align: left; vertical-align: top; width:90px">Main Vendor-Description</th>
        <th style="text-align: left; vertical-align: top; width:90px">Current Vendor Site-Description</th>
        <th style="text-align: left; vertical-align: top; width:60px">Requestor</th>
        <th style="text-align: left; vertical-align: top; width:80px">Request date</th>
        <th style="text-align: left; vertical-align: top; width:80px">Main Vendor linked to Alt. Site</th>
        <th style="text-align: left; vertical-align: top; width:80px">Alternative Site to be<br/>developed</th>
        <th style="text-align: left; vertical-align: top; width:90px">Target BCP</th>
        <th style="text-align: left; vertical-align: top; width:90px">Priority</th>
        <th style="text-align: left; vertical-align: top; width:60px">Cost Savings</th>
        <th style="text-align: left; vertical-align: top; width:80px">Estimated Savings in CHF</th>
        <th style="text-align: left; vertical-align: top; width:60px">GHG Reduction</th>
        <th style="text-align: left; vertical-align: top; width:240px">Remarks</th>
        <th style="text-align: left; vertical-align: top; width:90px">Procurement<br/> Specialist</th>
        <th style="text-align: left; vertical-align: top; width:90px">Business<br/> Partner</th>
        <th style="text-align: left; vertical-align: top; width:90px">Procurement<br/> Manager</th>
        <th style="text-align: left; vertical-align: top; width:90px">CTAG</th>
        <th style="text-align: left; vertical-align: top; width:90px">SQA</th>
        <th style="text-align: left; vertical-align: top; width:90px">QA in the<br/>Factory</th>
      </tr>
    </thead>
    <tbody>`;
  for (let i = 0; i < bcpRequestArray.length; i++) {
    const bcp = bcpRequestArray[i].actualBCPObject[0];
    let currentVendorSite;
    //logger.info("::::bcp.get-BCP.currentVendorSiteIdProp:::", bcp.get(BCP.currentVendorSiteIdProp), !bcp.get(BCP.currentVendorSiteIdProp))
    if (!bcp.get(BCP.currentVendorSiteIdProp)) {
      currentVendorSite = await getCurrentVendorSite(bcp, $)
    } else {
      currentVendorSite = bcp.get(BCP.currentVendorSiteIdProp) + "-" + bcp.get(BCP.currentVendorSiteDescriptionProp)
    }
    emailContent += `
    <tr>
      <td style="text-align: left; vertical-align:top; width:90px" >${bcp.get(BCP.plantIdProp) || getNotAvailableText()}</td>
      <td style="text-align: left; vertical-align:top; width:200px" >${(bcp.get(BCP.materialIdProp) + " - " + (bcp.get(BCP.materialDescriptionProp) || getNotAvailableText())) || getNotAvailableText()}</td>
      <td style="text-align: left; vertical-align:top; width:120px" >${bcp.get(BCP.specificationProp) || getNotAvailableText()}</td>
      <td style="text-align: left; vertical-align:top; width:180px" >${bcp.get(BCP.mainVendorIdProp) ? bcp.get(BCP.mainVendorIdProp) + ":" + (bcp.get(BCP.mainVendorDescriptionProp) || getNotAvailableText()) : getNotAvailableText()}</td>
      <td style="text-align: left; vertical-align:top;width:180px" > ${currentVendorSite}</td>
      <td style="text-align: left; vertical-align:top;width:60px" >${getPersonName(bcp.get(BCP.requestorProp))?.fullName || getNotAvailableText()}</td>
      <td style="text-align: left; vertical-align:top;width:80px" >${getFormattedDate(bcp.get(BCP.requestDateProp))}</td>
      <td style="text-align: left; vertical-align:top;width:80px" >${bcp.get(BCP.mainVendorLinkedAltVendorProp) || getNotAvailableText()}</td>
      <td style="text-align: left; vertical-align:top;width:80px" >${bcp.get(BCP.alternativeVendorCodeProp) || getNotAvailableText()}</td>
      <td style="text-align: left; vertical-align:top;width:90px" >${getTargetBCPText(bcp.get(BCP.targetBCPProp)) || getNotAvailableText()}</td>
      <td style="text-align: left; vertical-align:top;width:90px" >${bcp.get(BCP.priorityProp) || getNotAvailableText()}</td>
      <td style="text-align: left; vertical-align:top;width:60px" >${bcp.get(BCP.costSavingsProp) || "No"}</td>
      <td style="text-align: left; vertical-align:top;width:90px" >${bcp.get(BCP.inputSavingEstimatesProp) || getNotAvailableText()}</td>
      <td style="text-align: left; vertical-align:top;width:60px" >${bcp.get(BCP.ghgReductionProp) || "No"}</td>
      <td style="text-align: left; vertical-align:top;width:240px" >${bcp.get(BCP.remarkProp) || getNotAvailableText()}</td>
      <td style="text-align: left; vertical-align:top;width:90px" >${getPersonName(bcp.get(BCP.procurementSpecialistProp))?.fullName || getNotAvailableText()}</td>
      <td style="text-align: left; vertical-align:top;width:90px" >${getPersonName(bcp.get(BCP.businessPartnerProp))?.fullName || getNotAvailableText()}</td>
      <td style="text-align: left; vertical-align:top;width:90px" >${getPersonName(bcp.get(BCP.procurementManagerProp))?.fullName || getNotAvailableText()}</td>
      <td style="text-align: left; vertical-align:top;width:90px" >${getPersonName(bcp.get(BCP.technicalApplicationGroupProp))?.fullName || getNotAvailableText()}</td>
      <td style="text-align: left; vertical-align:top;width:90px" >${getPersonName(bcp.get(BCP.qualityAssuranceProp))?.fullName || getNotAvailableText()}</td>
      <td style="text-align: left; vertical-align:top;width:90px" >${getPersonName(bcp.get(BCP.qaInFactoryProp))?.fullName || getNotAvailableText()}</td>
    </tr>`;
  }

  emailContent += `
    </tbody>
  </table>
  
  <p>Please do not reply to this email as this is an automatically generated notification.</p>
  <p>Thank you for your collaboration.</p>
  <p>Your Ensuring Supply Team</p>`;
  return emailContent;
};

// This function gets the current vendor site for the mentioned plant and material if the current vendor is not saved in database
export const returnCurrentVendorSite = async (bcp, $) => {
  const logger = getLogger('BCPQAEmailTemplate')
  const body = { offset: '0', limit: '100', plants: [bcp.get(BCP.plantIdProp)], materials: [bcp.get(BCP.materialIdProp)] };
  let concatenatedString = '';
  let response = await callProxyFunction(body, $);
  //logger.info("BCPQAEmailTemplate: Api Response", response)
  if (response.statusCode === 500) {
    logger.error(`API Error: ${response.statusCode} - ${response.message}`);
    return "";
  } else {
    let uniqueVendorList = uniqueListByProperty(response.materials)?.slice(0, 2)
    for (var i = 0; i < uniqueVendorList.length; i++) {
      const item = uniqueVendorList[i];
      concatenatedString += item.vendorSiteNumber + " - " + item.vendorSiteDescription + "\n"      
    }
    //logger.info(concatenatedString, "Concatenated vendor site String")
    return concatenatedString;
  }
}


export const getFullURL = () => {
  return EnvironmentMap[Config.getParameter("ENV")] || "";
}









